import { render, staticRenderFns } from "./manipulacao.vue?vue&type=template&id=4574289f"
import script from "./manipulacao.ts?vue&type=script&lang=js&external"
export * from "./manipulacao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4574289f')) {
      api.createRecord('4574289f', component.options)
    } else {
      api.reload('4574289f', component.options)
    }
    module.hot.accept("./manipulacao.vue?vue&type=template&id=4574289f", function () {
      api.rerender('4574289f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/manipulacao/manipulacao.vue"
export default component.exports